// Utilidad para diagnosticar problemas de Firebase
import { auth, db } from '../firebase/config';
import { collection, getDocs, query, limit } from 'firebase/firestore';

// Función para verificar la configuración de Firebase
export const checkFirebaseConfig = () => {
  console.log("🔍 === DIAGNÓSTICO DE FIREBASE ===");
  
  // Verificar configuración de autenticación
  console.log("🔐 Auth Config:", {
    app: auth.app?.name || 'undefined',
    currentUser: auth.currentUser?.email || 'No user logged in',
    languageCode: auth.languageCode,
    tenantId: auth.tenantId || 'No tenant'
  });
  
  // Verificar configuración de la app
  if (auth.app?.options) {
    console.log("⚙️ Firebase Options:", {
      projectId: auth.app.options.projectId,
      authDomain: auth.app.options.authDomain,
      apiKey: auth.app.options.apiKey ? "✅ Configured" : "❌ Missing",
      appId: auth.app.options.appId ? "✅ Configured" : "❌ Missing"
    });
  }
  
  // Verificar variables de entorno
  console.log("🌍 Environment Variables:", {
    NODE_ENV: process.env.NODE_ENV,
    REACT_APP_FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY ? "✅ Set" : "❌ Missing",
    REACT_APP_FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID ? "✅ Set" : "❌ Missing",
    REACT_APP_FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ? "✅ Set" : "❌ Missing"
  });
};

// Función para verificar la conexión a Firestore
export const checkFirestoreConnection = async () => {
  try {
    console.log("🔍 Testing Firestore connection...");
    
    // Intentar obtener un documento de la colección usuarios
    const usersRef = collection(db, 'usuarios');
    const testQuery = query(usersRef, limit(1));
    const snapshot = await getDocs(testQuery);
    
    console.log("✅ Firestore Connection: SUCCESS");
    console.log(`📊 Found ${snapshot.size} user(s) in collection`);
    
    if (snapshot.size > 0) {
      const firstUser = snapshot.docs[0];
      console.log("👤 Sample user data:", {
        id: firstUser.id,
        hasRole: !!firstUser.data().rol,
        hasStatus: !!firstUser.data().status,
        hasName: !!firstUser.data().nombre
      });
    }
    
    return true;
  } catch (error) {
    console.error("❌ Firestore Connection: FAILED");
    console.error("Error details:", error);
    return false;
  }
};

// Función para verificar si un usuario específico existe
export const checkUserExists = async (email) => {
  try {
    console.log(`🔍 Checking if user exists: ${email}`);
    
    const userRef = collection(db, 'usuarios');
    const snapshot = await getDocs(userRef);
    
    const users = [];
    snapshot.forEach(doc => {
      users.push({
        id: doc.id,
        email: doc.id,
        rol: doc.data().rol,
        status: doc.data().status,
        nombre: doc.data().nombre
      });
    });
    
    console.log(`📊 Total users in database: ${users.length}`);
    
    const targetUser = users.find(user => user.email === email);
    
    if (targetUser) {
      console.log(`✅ User found:`, targetUser);
      return targetUser;
    } else {
      console.log(`❌ User NOT found: ${email}`);
      console.log("📋 Available users:", users.map(u => u.email));
      return null;
    }
  } catch (error) {
    console.error("❌ Error checking user:", error);
    return null;
  }
};

// Función completa de diagnóstico
export const runFullDiagnostic = async (email = null) => {
  console.log("🚀 === INICIANDO DIAGNÓSTICO COMPLETO ===");
  
  // 1. Verificar configuración
  checkFirebaseConfig();
  
  // 2. Verificar conexión a Firestore
  const firestoreOK = await checkFirestoreConnection();
  
  // 3. Si se proporciona un email, verificar usuario específico
  if (email && firestoreOK) {
    await checkUserExists(email);
  }
  
  console.log("✅ === DIAGNÓSTICO COMPLETADO ===");
};

// Función para logging de errores de autenticación
export const logAuthError = (error, email) => {
  console.log("🔥 === ERROR DE AUTENTICACIÓN DETALLADO ===");
  console.log("📧 Email:", email);
  console.log("❌ Error Code:", error.code);
  console.log("📝 Error Message:", error.message);
  console.log("🕒 Timestamp:", new Date().toISOString());
  console.log("🌐 User Agent:", navigator.userAgent);
  
  // Sugerencias específicas por tipo de error
  switch (error.code) {
    case 'auth/invalid-credential':
      console.log("💡 Sugerencias:");
      console.log("  • Verificar que el email esté correcto");
      console.log("  • Verificar que la contraseña sea correcta");
      console.log("  • Confirmar que el usuario existe en Firebase Auth");
      console.log("  • Verificar que el usuario existe en Firestore");
      break;
    case 'auth/user-not-found':
      console.log("💡 Sugerencias:");
      console.log("  • El usuario no existe en Firebase Auth");
      console.log("  • Crear el usuario en Firebase Auth primero");
      break;
    case 'auth/wrong-password':
      console.log("💡 Sugerencias:");
      console.log("  • La contraseña es incorrecta");
      console.log("  • Resetear la contraseña si es necesario");
      break;
    default:
      console.log("💡 Error no reconocido, verificar configuración general");
  }
  
  console.log("🏁 === FIN DEL LOG DE ERROR ===");
}; 